/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { SysqueFrameModule } from '../../../../../../../shared/ui/src/lib/components/sysque-frame';
import { SysqueAlertModule } from '../../../../../../../shared/ui/src/lib/components/sysque-alert';
import { ImportScheduleComponent } from './import-schedule.component';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [{ path: 'dialog/import-schedule-dialog', component: ImportScheduleComponent }];

@NgModule({
  declarations: [ImportScheduleComponent],
  imports: [
    CommonModule,
    FormsModule,
    DxButtonModule,
    SysqueFrameModule,
    SysqueAlertModule,
    AlertModule,
    RouterModule.forChild(routes),
  ],
  exports: [ImportScheduleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ImportScheduleModule {}
